import React from 'react';
import { CLOSING_LINE, costRows } from '../data/unstuckContent';
export function CostSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="cost-title" data-id="element-35" data-mp="9bofpw7mn7bl">
      <div className="mx-auto max-w-3xl px-5" data-id="element-36" data-mp="4kg3ytitr9v9">
        <h2 id="cost-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-37" data-mp="4j506tpdq245">
          What does not having it cost?
        </h2>

        <div className="mt-8 flex items-baseline justify-between text-[9px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-38" data-mp="3mr2s2clu0b15">
          <span data-id="element-39" data-mp="3hst00avelqjr">Without UNSTUCK</span>
          <span data-id="element-40" data-mp="3htuaoe8icb0y">Real cost</span>
        </div>

        <ul className="mt-2 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-41" data-mp="3ctgcrp0mehgn">
          {costRows.map(row => <li key={row.situation} className="flex flex-col gap-1 py-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6" data-id="element-42" data-mp="1fzuy7pjnfnmo">
              <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-ivory-100" data-id="element-43" data-mp="p7bmn8jodyhn">
                {row.situation}
              </span>
              <span className="text-[14px] leading-snug text-rose sm:text-right" data-id="element-44" data-mp="t6txtclp2v7a">
                → {row.result}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 text-center font-display text-xl italic text-ivory-50 sm:text-2xl" data-id="element-45" data-mp="k90c0vlk3jyd">
          {CLOSING_LINE}
        </p>
      </div>
    </section>;
}